<template>
  <div>
    <div class="t_step_box">
      <div v-preventReClick class="t_step_item" :class="{color_black:step==1}" @click="choosestep(1)">
        <img v-if="step==1" src="@/assets/img/rstep1t.png" class="t_step_img">
        <img v-if="step!=1" src="@/assets/img/rstep1z.png" class="t_step_img">
        个人认证信息
      </div>
      <div class="t_step_line">
        <img v-if="step==2" src="@/assets/img/rsteplinet.png">
        <img v-if="step<2" src="@/assets/img/rsteplinef.png">
        <img v-if="step>2" src="@/assets/img/rsteplinez.png">
      </div>
      <div v-preventReClick class="t_step_item" :class="{color_black:step==2}" @click="choosestep(2)">
        <img v-if="step==2" src="@/assets/img/rstep2t.png" class="t_step_img">
        <img v-if="step<2" src="@/assets/img/rstep2f.png" class="t_step_img">
        <img v-if="step>2" src="@/assets/img/rstep2z.png" class="t_step_img">
        单位认证信息
      </div>
      <div class="t_step_line">
        <img v-if="step==3" src="@/assets/img/rsteplinet.png">
        <img v-if="step<3" src="@/assets/img/rsteplinef.png">
        <img v-if="step>3" src="@/assets/img/rsteplinez.png">
      </div>
      <div v-preventReClick class="t_step_item" :class="{color_black:step==3}" @click="choosestep(3)">
        <img v-if="step==3" src="@/assets/img/rstep3t.png" class="t_step_img">
        <img v-if="step<3" src="@/assets/img/rstep3f.png" class="t_step_img">
        <img v-if="step>3" src="@/assets/img/rstep3z.png" class="t_step_img">
        法人/经营者认证信息
      </div>
      <div class="t_step_line">
        <img v-if="step==4" src="@/assets/img/rsteplinet.png">
        <img v-if="step<4" src="@/assets/img/rsteplinef.png">
        <img v-if="step>4" src="@/assets/img/rsteplinez.png">
      </div>
      <div v-preventReClick class="t_step_item" :class="{color_black:step==4}" @click="choosestep(4)">
        <img v-if="step==4" src="@/assets/img/rstep4t.png" class="t_step_img">
        <img v-if="step<4" src="@/assets/img/rstep4f.png" class="t_step_img">
        <img v-if="step>4" src="@/assets/img/rstep4z.png" class="t_step_img">
        涉及化学品登记
      </div>
      <div class="t_step_line">
        <img v-if="step==5" src="@/assets/img/rsteplinet.png">
        <img v-if="step<5" src="@/assets/img/rsteplinef.png">
        <img v-if="step>5" src="@/assets/img/rsteplinez.png">
      </div>
      <div v-preventReClick class="t_step_item" :class="{color_black:step==5}" @click="choosestep(5)">
        <img v-if="step==5" src="@/assets/img/rstep5t.png" class="t_step_img">
        <img v-if="step<5" src="@/assets/img/rstep5f.png" class="t_step_img">
        <img v-if="step>5" src="@/assets/img/rstep5z.png" class="t_step_img">
        注册信息预览
      </div>
      <div class="t_step_line">
        <img v-if="step==6" src="@/assets/img/rsteplinet.png">
        <img v-if="step<6" src="@/assets/img/rsteplinef.png">
        <img v-if="step>6" src="@/assets/img/rsteplinez.png">
      </div>
      <div v-preventReClick class="t_step_item" :class="{color_black:step==6}" @click="choosestep(6)">
        <img v-if="step==6" src="@/assets/img/rstep6t.png" class="t_step_img">
        <img v-if="step<6" src="@/assets/img/rstep6f.png" class="t_step_img">
        提交注册申请
      </div>
    </div>
    <div>
      <!-- <button    v-preventReClick   @click="step--">-1</button>
      <button    v-preventReClick   @click="step++">+1</button>
      {{step}} -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rwsptop',
  props: {
    step: Number
  },
  data() {
    return {
      // step:3
    }
  },
  created: function() {

  },
  methods: {
    choosestep(num) {
      if (this.step != 6) {
        if (num < this.step) {
          // this.step=num
          this.$emit('nextstep', num)
        }
      }
    }
  }
}
</script>

<style scoped>
  .t_step_box{
    display: flex;
    justify-content: center;
    padding: 30px 0;
    background-color: white;
  }
  .t_step_img{
    width: 48px;
    display: flex;
    margin-bottom: 10px;
  }
  .t_step_item{
    font-size: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #8B8B8B;
    cursor: pointer;
  }
  .color_black{
    color: #333333;
  }
  .t_step_line{
    margin-top: 10px;
  }
  .t_step_line img{
    width: 100px;
  }
</style>
